const Layout = () => import('@/layouts/index.vue');
const routes = {
    path: '/manage/iot',
    component: Layout,
    redirect: '/manage/iot/device',
    name: 'IotManage',
    meta: {
        title: '硬件',
        icon: 'ion:hardware-chip-outline',
    },
    children: [
        {
            path: 'device',
            name: 'IotManageDevice',
            meta: {
                title: '设备管理',
                icon: 'ion:watch-outline',
            },
            children: [
                {
                    path: '',
                    name: 'IotManageDeviceList',
                    component: () => import('@/views/iot/device/list.vue'),
                    meta: {
                        title: '设备列表',
                        sidebar: false,
                        cache: ['IotManageDeviceCreate', 'IotManageDeviceEdit'],
                    },
                },
                {
                    path: 'create',
                    name: 'IotManageDeviceCreate',
                    component: () => import('@/views/iot/device/detail.vue'),
                    meta: {
                        title: '新增设备',
                        sidebar: false,
                        activeMenu: '/manage/iot/device',
                    },
                },
                {
                    path: 'edit/:id',
                    name: 'IotManageDeviceEdit',
                    component: () => import('@/views/iot/device/detail.vue'),
                    meta: {
                        title: '编辑设备',
                        sidebar: false,
                        activeMenu: '/manage/iot/device',
                    },
                },
            ],
        },
        {
            path: 'product-model',
            name: 'IotManageProductModel',
            meta: {
                title: '产品型号管理',
                icon: 'ep:cpu',
            },
            children: [
                {
                    path: '',
                    name: 'IotManageProductModelList',
                    component: () => import('@/views/iot/product_model/list.vue'),
                    meta: {
                        title: '产品型号列表',
                        sidebar: false,
                        cache: ['IotManageProductModelCreate', 'IotManageProductModelDetail'],
                    },
                },
                {
                    path: 'create',
                    name: 'IotManageProductModelCreate',
                    component: () => import('@/views/iot/product_model/detail.vue'),
                    meta: {
                        title: '新增产品型号',
                        sidebar: false,
                        activeMenu: '/manage/iot/product-model',
                    },
                },
                {
                    path: 'detail/:id',
                    name: 'IotManageProductModelDetail',
                    component: () => import('@/views/iot/product_model/detail.vue'),
                    meta: {
                        title: '产品型号详情',
                        sidebar: false,
                        activeMenu: '/manage/iot/product-model',
                    },
                },
            ],
        },
        {
            path: 'bluetooth-name',
            name: 'IotManageBluetoothName',
            meta: {
                title: '蓝牙名管理',
                icon: 'ep:connection',
            },
            children: [
                {
                    path: '',
                    name: 'IotManageBluetoothNameList',
                    component: () => import('@/views/iot/bluetooth_name/list.vue'),
                    meta: {
                        title: '蓝牙名列表',
                        sidebar: false,
                    },
                },
            ],
        },
        {
            path: 'data-migration',
            name: 'IotDataMigration',
            meta: {
                title: '数据迁移',
                icon: 'ep:data-line',
            },
            children: [
                {
                    path: '',
                    name: 'IotDataMigrationIndex',
                    component: () => import('@/views/iot/data_migration/index.vue'),
                    meta: {
                        title: '数据迁移',
                        sidebar: false,
                    },
                },
                {
                    path: 'export',
                    name: 'IotDataMigrationExport',
                    component: () => import('@/views/iot/data_migration/export.vue'),
                    meta: {
                        title: '导出迁移包',
                        sidebar: false,
                        activeMenu: '/manage/iot/data-migration',
                    },
                },
                {
                    path: 'import',
                    name: 'IotDataMigrationImport',
                    component: () => import('@/views/iot/data_migration/import.vue'),
                    meta: {
                        title: '导入迁移包',
                        sidebar: false,
                        activeMenu: '/manage/iot/data-migration',
                    },
                },
            ],
        },
        {
            path: 'device/models',
            name: 'IotManageDeviceModels',
            meta: {
                title: '设备型号管理(旧)',
                icon: 'material-symbols:devices-wearables-outline',
            },
            children: [
                {
                    path: '',
                    name: 'IotManageDeviceModelsList',
                    component: () => import('@/views/iot/models/list.vue'),
                    meta: {
                        title: '设备型号列表',
                        sidebar: false,
                        cache: ['IotManageDeviceModelsCreate', 'IotManageDeviceModelsEdit'],
                    },
                },
                {
                    path: 'create',
                    name: 'IotManageDeviceModelsCreate',
                    component: () => import('@/views/iot/models/detail.vue'),
                    meta: {
                        title: '新增设备型号',
                        // i18n: 'route.general.department.create',
                        sidebar: false,
                        activeMenu: '/manage/iot/device/models',
                    },
                },
                {
                    path: 'edit/:id',
                    name: 'IotManageDeviceModelsEdit',
                    component: () => import('@/views/iot/models/detail.vue'),
                    meta: {
                        title: '编辑设备型号',
                        // i18n: 'route.general.department.edit',
                        sidebar: false,
                        activeMenu: '/manage/iot/device/models',
                    },
                },
            ],
        },
        {
            path: 'device/batch',
            name: 'IotManageDeviceBatch',
            meta: {
                title: '设备批次管理',
                icon: 'material-symbols:inventory-2-outline',
            },
            children: [
                {
                    path: '',
                    name: 'IotManageDeviceBatchList',
                    component: () => import('@/views/iot/batch/list.vue'),
                    meta: {
                        title: '设备批次列表',
                        sidebar: false,
                        cache: ['IotManageDeviceBatchCreate', 'IotManageDeviceBatchDetail'],
                    },
                },
                {
                    path: 'create',
                    name: 'IotManageDeviceBatchCreate',
                    component: () => import('@/views/iot/batch/detail.vue'),
                    meta: {
                        title: '创建设备批次',
                        sidebar: false,
                        activeMenu: '/manage/iot/device/batch',
                    },
                },
                {
                    path: 'detail/:batchCode',
                    name: 'IotManageDeviceBatchDetail',
                    component: () => import('@/views/iot/batch/detail.vue'),
                    meta: {
                        title: '批次详情',
                        sidebar: false,
                        activeMenu: '/manage/iot/device/batch',
                    },
                },
            ],
        },
        {
            path: 'third-party-models',
            name: 'IotThirdPartyModels',
            meta: {
                title: '三方产品管理',
                icon: 'material-symbols:device-hub',
            },
            children: [
                {
                    path: '',
                    name: 'IotThirdPartyModelsList',
                    component: () => import('@/views/iot/thirdPartyModels/list.vue'),
                    meta: {
                        title: '三方产品型号列表',
                        sidebar: false,
                        cache: ['IotThirdPartyModelsCreate', 'IotThirdPartyModelsDetail'],
                    },
                },
                {
                    path: 'create',
                    name: 'IotThirdPartyModelsCreate',
                    component: () => import('@/views/iot/thirdPartyModels/detail.vue'),
                    meta: {
                        title: '创建三方产品',
                        sidebar: false,
                        activeMenu: '/manage/iot/third-party-models',
                    },
                },
                {
                    path: 'detail/:id',
                    name: 'IotThirdPartyModelsDetail',
                    component: () => import('@/views/iot/thirdPartyModels/detail.vue'),
                    meta: {
                        title: '型号详情',
                        sidebar: false,
                        activeMenu: '/manage/iot/third-party-models',
                    },
                },
            ],
        },
    ],
};
export default routes;
